// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__axDsR","title":"InfoRow_title__1_eB7"};